(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const title = params.get('gto_title');
    const sku = params.get('gto_sku');
    const path = params.get('gto_url');
    const field = document.getElementById('ContactForm-body');
    if (field && !field.value.trim() && title && sku && path && /^\/products\/[a-z0-9-]+$/.test(path)) {
      field.value = `${title.slice(0, 500)}\nInventory ID: ${sku.slice(0, 50)}\n${window.location.origin}${path}\n\n`;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gto-contact-06"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const title = params.get('gto_title');
    const sku = params.get('gto_sku');
    const path = params.get('gto_url');
    const panel = document.querySelector('.gto-contact-06__form-panel');
    if (!panel || !title || !sku || !path || !/^P\d{3}-[A-Z]$/.test(sku) || !/^\/products\/[a-z0-9-]+$/.test(path)) return;
    const reference = panel.querySelector('input[name="contact[Reference]"]');
    const body = panel.querySelector('textarea[name="contact[body]"]');
    if (reference && !reference.value.trim()) reference.value = sku;
    if (body && !body.value.trim()) body.value = `${title.slice(0, 500)}\n${panel.dataset.inventoryLabel}: ${sku}\n${window.location.origin}${path}\n\n`;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gto-invoice-received-16"]) return;
  try {
    
  (() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('gto_invoice_received') !== '1') return;

    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart/clear.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart clear failed with status ${response.status}`);
        return response.json();
      })
      .then(() => {
        url.searchParams.delete('gto_invoice_received');
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        window.location.reload();
      })
      .catch((error) => {
        console.error('[GTO invoice] Unable to clear cart after a successful invoice request.', error);
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gto-invoice-request-15"]) return;
  try {
    
  (() => {
    const formatPhone = (value) => {
      const digits = value.replace(/\D/g, '');
      if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      if (digits.length === 11 && digits[0] === '1') return `1-${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
      return value;
    };
    const formatInput = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-gto-invoice-phone]')) return;
      if (event.type === 'input' && input.selectionStart !== input.value.length) return;
      const formatted = formatPhone(input.value);
      if (formatted !== input.value) input.value = formatted;
    };
    document.addEventListener('input', formatInput);
    document.addEventListener('change', formatInput);
    document.addEventListener('focusout', formatInput);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
